import { render, staticRenderFns } from "./wangning.vue?vue&type=template&id=4ac6aa08&"
import script from "./wangning.vue?vue&type=script&lang=js&"
export * from "./wangning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports